import { Component } from '@angular/core';
import { Router, ActivatedRoute, Params  } from '@angular/router';
//import { Router} from '@angular/router';
import { PhotoService} from './service.photo';
import { CommonService} from './service.common';
@Component({
    selector: 'page-content',
    templateUrl: './html/pageContent.html'
})
export class PageContentComponent{
    constructor(
        private commonService: CommonService,
        private photoService: PhotoService,
        private route: ActivatedRoute,
        private router: Router
    ) {}
//	private showingPhotoId: number = null;
//	private showingAlbumId: string = null;
    ngOnInit() {
        // useful to get query string
        //let buyingPhotoId = this.route.snapshot.queryParams['photoId'];
// 		this.showingPhotoId = this.route.snapshot.queryParams['pid'];
// 		this.showingAlbumId = this.route.snapshot.queryParams['aid'];
// 		if(this.showingPhotoId != null && this.showingAlbumId != null){
// 			await this.photoService.setAlbumsWithoutInitPhotos();
// 			await this.photoService.setCurrentAlbumByAlbumId(this.showingAlbumId)
// 			await this.commonService.getBackToReferer();
// 			//console.log(this.commonService.backToReferer);
// //			await this.getBackToReferer();
// //			.then(function(albumId){
// 				//this.setResultWithKeyword();
// 			console.log('this.showingPhotoId');
// 			console.log(this.showingPhotoId);

// 			this.commonService.myOpenPhotoSwipe(this.showingPhotoId);
// //			})
// 			;

// 		}
// 		else{
// 			this.photoService.setAlbums();
// 		}
        this.photoService.setAlbums();
 
    }

    
}


// WEBPACK FOOTER //
// ./src/app/pageContent.ts